<div id="wrapper">
  <app-loader></app-loader>
  <router-outlet *ngIf="themeService.themeLoaded"></router-outlet>
</div>